(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    const open = () => {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-cart-open');
    };
    const close = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-cart-open');
    };

    document.addEventListener('click', (e) => {
      const openEl = e.target.closest('[data-cart-drawer-open]');
      const closeEl = e.target.closest('[data-cart-drawer-close]');
      if (openEl) {
        e.preventDefault();
        open();
        return;
      }
      if (closeEl && drawer.contains(closeEl)) {
        e.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
